import React, { useState, useContext, useEffect } from 'react';
import './Addlead.css';
import './Leads.css';
import Url from '../Url';
import { useLocation } from 'react-router-dom';
import { LoginContext } from '../Login/LoginContext';

const AddLeadComponent = () => {
    const { loginResult } = useContext(LoginContext);
    const location = useLocation();
    const [settings, setSettings] = useState({
        defaultBusinessType: '',
        removeLeadingZero: false,
        showSettings: false
    });
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'o') {
                e.preventDefault();
                setSettings(prev => ({ ...prev, showSettings: true }));
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
  
    const userId = loginResult.user_id;
    const editLead = location.state?.editLead || null;

    const [newLead, setNewLead] = useState({
        name: '',
        companyname: '',
        email: 'noemail@gmail.com',
        mobile: '',
        address: '',
        productName: 'Audiutsierp-singleuser',
        leadSource: 'Self Lead',
        Business_type: '',
    });

    const [leadSources, setLeadSources] = useState([]);
    const [businessTypes, setBusinessTypes] = useState([]);
    const [popup, setPopup] = useState({ show: false, message: '', type: 'info' });
    const isEditing = !!editLead;

    useEffect(() => {
        if (editLead) {
            setNewLead({
                name: editLead.name || '',
                companyname: editLead.companyname || '',
                email: editLead.email || '',
                mobile: editLead.mobile || '',
                address: editLead.address || '',
                productName: editLead.productName || '',
                leadSource: editLead.leadSource || '',
                Business_type: editLead.Business_type || '',
            });
        }
    }, [editLead]);

    useEffect(() => {
        const fetchLeadSources = async () => {
            try {
                const response = await fetch(`${Url.Url}/get_report?data={"report_id":"11"}`);
                const data = await response.json();
                if (data && Array.isArray(data)) {
                    setLeadSources(data);
                } else {
                    console.error('Invalid lead source format', data);
                }
            } catch (error) {
                console.error('Error fetching lead sources:', error);
            }
        };

        const fetchBusinessTypes = async () => {
            try {
                const response = await fetch(`${Url.Url}/get_report?data={"report_id":"15"}`);
                const data = await response.json();
                if (data && Array.isArray(data)) {
                    setBusinessTypes(data);
                } else {
                    console.error('Invalid business types format', data);
                }
            } catch (error) {
                console.error('Error fetching business types:', error);
            }
        };

        fetchLeadSources();
        fetchBusinessTypes();
    }, []);
    const [isBusinessTypeManual, setIsBusinessTypeManual] = useState(false);
    const handlePasteMobile = (e) => {
        let pasted = e.clipboardData.getData('Text');
        pasted = pasted.replace(/\D/g, '');

        if (settings.removeLeadingZero && pasted.startsWith('0')) {
            pasted = pasted.substring(1);
        }

        pasted = pasted.slice(0, 10);

        setNewLead(prev => ({
            ...prev,
            mobile: pasted
        }));

        e.preventDefault();
    };
    useEffect(() => {
        if (!isBusinessTypeManual) {
            setNewLead(prev => ({
                ...prev,
                Business_type: settings.defaultBusinessType || ''
            }));
        }
    }, [settings.defaultBusinessType]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === 'mobile') {
            let valueClean = value.replace(/\D/g, '');

            // ✅ REMOVE 0 if setting enabled
            if (settings.removeLeadingZero && valueClean.startsWith('0')) {
                valueClean = valueClean.substring(1);
            }

            if (valueClean.length > 10) valueClean = valueClean.slice(0, 10);

            setNewLead(prev => ({
                ...prev,
                mobile: valueClean
            }));
            return;
        }
        if (name === 'Business_type') {
            setIsBusinessTypeManual(true); // ✅ user changed manually

            setNewLead(prev => ({
                ...prev,
                Business_type: value
            }));
            return;
        }
        if (name === 'email') {
            updatedValue = updatedValue.toLowerCase();
        }

        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue.trimStart();
        }

        setNewLead((prev) => ({ ...prev, [name]: updatedValue }));
    };

    const showPopup = (message, type = 'info') => {
        setPopup({ show: true, message, type });
    };

    const closePopup = () => {
        setPopup({ show: false, message: '', type: 'info' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newLead.name.trim()) return showPopup('Name is required', 'error');
        if (!newLead.companyname.trim()) return showPopup('Company name is required', 'error');
        if (!newLead.email.includes('@')) return showPopup('Enter a valid email', 'error');
        if (!newLead.productName) return showPopup('Please select a product', 'error');
        if (!newLead.leadSource) return showPopup('Please select a lead source', 'error');
        if (!newLead.Business_type) return showPopup('Please select a business type', 'error');
        if (!userId) return showPopup('User ID missing. Please log in again.', 'error');

        const payload = {
            data: {
                tbl_lead: [
                    {
                        ...newLead,

                        // ✅ send ORIGINAL values only
                        mobile: newLead.mobile,
                        Business_type: newLead.Business_type,

                        user_id: userId,
                        postid: isEditing ? 3 : 1,
                        id: isEditing ? editLead.id : undefined,
                    },
                ],
            },
        };

        try {
            const response = await fetch(`${Url.Url}/post_data`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                showPopup(
                    isEditing ? 'Lead updated successfully!' : 'Lead saved successfully!',
                    'success'
                );
                if (!isEditing) {
                    setNewLead({
                        name: '',
                        companyname: '',
                        email: 'noemail@gmail.com',
                        mobile: '',
                        address: '',
                        productName: 'Audiutsierp-singleuser',
                        leadSource: 'Self Lead',

                        // ✅ keep from settings
                        Business_type: settings.defaultBusinessType || '',
                    });

                    // ✅ reset manual flag
                    setIsBusinessTypeManual(false);
                }
            } else {
                showPopup(data?.message || 'Failed to save lead', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            showPopup('Network error: ' + error.message, 'error');
        }
    };

    return (
        <div className="lead-form-container">
            <h2 className="form-title">{isEditing ? 'Edit Lead' : 'Add New Lead'}</h2>
            <form className="lead-form" onSubmit={handleSubmit}>
                <input autoComplete="off" type="text" name="name" placeholder="Name" value={newLead.name} onChange={handleChange} required />
                <input autoComplete="off" type="text" name="companyname" placeholder="Company Name" value={newLead.companyname} onChange={handleChange} required />
                <input autoComplete="off" type="email" name="email" placeholder="Email" value={newLead.email} onChange={handleChange} required />
                <input
                    autoComplete="off"
                    type="tel"
                    name="mobile"
                    placeholder="Mobile"
                    value={newLead.mobile}
                    onChange={handleChange}
                    onPaste={handlePasteMobile}
                    pattern="[6-9][0-9]{9}"
                    maxLength="10"
                    minLength="10"
                    required
                />
                                <textarea name="address" placeholder="Address" rows="3" value={newLead.address} onChange={handleChange} maxLength={250} />

                <select name="productName" value={newLead.productName} onChange={handleChange} required>
                    <option disabled value="">-- Select Product --</option>
                    <option value="Audiutsierp-singleuser">Auditusierp single user</option>
                    <option value="Audiutsierp-dualuser">Auditusierp dual user</option>
                    <option value="Audiutsierp-multiuser">Auditusierp multi user</option>
                    <option value="Mobile-app">Mobile app</option>
                    <option value="Web-application">Web application</option>
                </select>

                <select name="leadSource" value={newLead.leadSource} onChange={handleChange} required>
                    <option disabled value="">-- Select Lead Source --</option>
                    {leadSources.map((source) => (
                        <option key={source.id} value={source.source_name}>{source.source_name}</option>
                    ))}
                </select>

                <select name="Business_type" value={newLead.Business_type} onChange={handleChange} required>
                    <option disabled value="">-- Select Business Type --</option>
                    {businessTypes.map((type) => (
                        <option key={type.id} value={type.Business_type}>{type.Business_type}</option>
                    ))}
                </select>

                <button type="submit" className="submit-btn">
                    {isEditing ? 'Update Lead' : 'Save Lead'}
                </button>
            </form>

            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box ${popup.type}`}>
                        <p>{popup.message}</p>
                        <button className="popup-close" onClick={closePopup}>OK</button>
                    </div>
                </div>
            )}
            {settings.showSettings && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Settings</h3>

                        <label>Default Business Type</label>
                        <select
                            value={settings.defaultBusinessType}
                            onChange={(e) =>
                                setSettings(prev => ({
                                    ...prev,
                                    defaultBusinessType: e.target.value
                                }))
                            }
                        >
                            <option value="">None</option>
                            {businessTypes.map((type) => (
                                <option key={type.id} value={type.Business_type}>
                                    {type.Business_type}
                                </option>
                            ))}
                        </select>

                        <div className="settings-checkbox">
                            <input
                                type="checkbox"
                                checked={settings.removeLeadingZero}
                                onChange={(e) =>
                                    setSettings(prev => ({
                                        ...prev,
                                        removeLeadingZero: e.target.checked
                                    }))
                                }
                            />
                            <span>Remove first 0 from mobile</span>
                        </div>

                        <button
                            className="popup-close"
                            onClick={() =>
                                setSettings(prev => ({ ...prev, showSettings: false }))
                            }
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddLeadComponent;
